// Constants extracted from LoginModule.js

// Constants
export const NAME = "login";
export const AUTH_SUPERADMIN_SUCCESS = "AUTH_SUPERADMIN_SUCCESS" + " " + NAME;
export const REMOVE_SUPERADMIN_AUTH = "REMOVE_SUPERADMIN_AUTH" + " " + NAME;
export const SET_DESIGNATION_LIST = "SET_DESIGNATION_LIST" + " " + NAME;
export const AUTH_USER_SUCCESS = "AUTH_USER_SUCCESS" + " " + NAME;
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS" + " " + NAME;

export const SET_LOADING_STATE = "SET_LOADING_STATE" + " " + NAME;
export const SET_GLOBAL_TRAY_ENABLED_STATE =
  "SET_GLOBAL_TRAY_ENABLED_STATE" + " " + NAME;
export const SET_GLOBAL_TRAY_RETRACTED_STATE =
  "SET_GLOBAL_TRAY_RETRACTED_STATE" + " " + NAME;
export const ADD_ICON_TO_HIDDEN_GLOBAL_TRAY_ICONS =
  "ADD_ICON_TO_HIDDEN_GLOBAL_TRAY_ICONS" + " " + NAME;
export const REMOVE_ICON_FROM_HIDDEN_GLOBAL_TRAY_ICONS =
  "REMOVE_ICON_FROM_HIDDEN_GLOBAL_TRAY_ICONS" + " " + NAME;
export const SET_GLOBAL_TRAY_UNREAD_COUNT =
  "SET_GLOBAL_TRAY_UNREAD_COUNT" + " " + NAME;
export const SET_TOAST_MSG = "SET_TOAST_MSG" + " " + NAME;
export const CLEAR_TOAST_MSG = "CLEAR_TOAST_MSG" + " " + NAME;
export const SET_ACTIVE_TAB = "SET_ACTIVE_TAB" + " " + NAME;
export const SET_CURRENT_PAGE_TITLE = "SET_CURRENT_PAGE_TITLE" + " " + NAME;
export const UPDATE_INPUT_FIELD = "UPDATE_INPUT_FIELD" + " " + NAME;
export const SET_CURRENT_SCREEN = "SET_CURRENT_SCREEN" + " " + NAME;
export const SET_LOGIN_ERROR = "SET_LOGIN_ERROR" + " " + NAME;
export const SET_HELP_CENTER_VIDEO_DIRECT_LINK =
  "SET_HELP_CENTER_VIDEO_DIRECT_LINK" + " " + NAME;
export const RETENTION_MODAL_STATUS = "RETENTION_MODAL_STATUS" + " " + NAME;
export const BIFURCATION_MODAL_STATUS = "BIFURCATION_MODAL_STATUS" + " " + NAME;
export const STATUS_CODES = {
  SUP_USR_EXSTS: "Your account already exists. ",
  SUP_DOM_MIS_MTCH_NO_ORG: "Domain doesn't match",
  SUP_DOM_MIS_MTCH_HS_ORG:
    "Domain doesn't match with your school domain, you can send approve request to admin",
};
export const UPDATE_ORGANIZATION_FILTERS =
  "UPDATE_ORGANIZATION_FILTERS" + " " + NAME;
export const INIT_ORGANIZATION_FILTERS =
  "INIT_ORGANIZATION_FILTERS" + " " + NAME;
export const UPDATE_ORGANIZATION_LIST_DATA =
  "UPDATE_ORGANIZATION_LIST_DATA" + " " + NAME;
export const SET_BIFURCATION_ACTION = "SET_BIFURCATION_ACTION" + " " + NAME;
export const SET_REDIRECT_URL = "SET_REDIRECT_URL" + " " + NAME;
export const SET_IS_USER_FROM_PUBLIC_ACCESS =
  "SET_IS_USER_FROM_PUBLIC_ACCESS" + " " + NAME;
export const SET_CHILD_STATUS = "SET_CHILD_STATUS" + " " + NAME;
export const SET_PRODUCT_UPDATE_DIRECT_LINK =
  "SET_PRODUCT_UPDATE_DIRECT_LINK" + " " + NAME;
export const SET_PRODUCT_UPDATE_MODAL_OPEN =
  "SET_PRODUCT_UPDATE_MODAL_OPEN" + " " + NAME;
export const SET_PRODUCT_UPDATE_MODAL_VISIBLE =
  "SET_PRODUCT_UPDATE_MODAL_VISIBLE" + " " + NAME;
export const SET_LAST_CHILD_STATUS = "SET_LAST_CHILD_STATUS" + " " + NAME;
export const SET_CHILD_DATA = "SET_CHILD_DATA" + " " + NAME;
export const SET_IS_UNMAPPED_PARENT = "SET_IS_UNMAPPED_PARENT" + " " + NAME;
export const SET_PARENT_LOGIN_TAB = "SET_PARENT_LOGIN_TAB" + " " + NAME;
export const SET_AUTH_REGION = "SET_AUTH_REGION" + " " + NAME;
export const SET_PARENT_INVITE_CODE = "SET_PARENT_INVITE_CODE" + " " + NAME;
export const UPDATE_USER_INFO = "UPDATE_USER_INFO" + " " + NAME;
export const UPDATE_INVITED_FAMILY_DATA =
  "UPDATE_INVITED_FAMILY_DATA" + " " + NAME;
export const UPDATE_INVITED_FAMILY_CHILD_DATA =
  "UPDATE_INVITED_FAMILY_CHILD_DATA" + " " + NAME;
export const UPDATE_ORGANIZATION_SWITCHER_DETAILS =
  "UPDATE_ORGANIZATION_SWITCHER_DETAILS" + " " + NAME;
export const SET_IDENTITY_POOL_DETAILS =
  "SET_IDENTITY_POOL_DETAILS" + " " + NAME;
export const SET_USER_IDENTITY_DETAILS =
  "SET_USER_IDENTITY_DETAILS" + " " + NAME;
export const SET_IDENTITY_SCREEN_FILTERS =
  "SET_IDENTITY_SCREEN_FILTERS" + " " + NAME;
export const SET_PORTAL_TYPE = "SET_PORTAL_TYPE" + " " + NAME;
export const SET_SELECTED_ICON = "SET_SELECTED_ICON" + " " + NAME;
export const SET_MESSAGING_USER_ID = "SET_MESSAGING_USER_ID" + " " + NAME;
export const SET_MESSAGING_CHAT_ID = "SET_MESSAGING_CHAT_ID" + " " + NAME;
export const SET_UNDER_MAINTENANCE = "SET_UNDER_MAINTENANCE" + " " + NAME;
export const TOGGLE_IS_SPRINKLR_CHAT_OPEN = "TOGGLE_IS_SPRINKLR_CHAT_OPEN";
export const UPDATE_SPRINKLR_UNREAD_MESSAGE_COUNT =
  "UPDATE_SPRINKLR_UNREAD_MESSAGE_COUNT" + NAME;
export const SET_IS_USER_CONFIGURATIONS_FETCHED =
  "SET_IS_USER_CONFIGURATIONS_FETCHED" + " " + NAME;
export const SET_USER_COURSES_IDS = `SET_USER_COURSES_IDS ${NAME}`;
export const SET_IDP_LIST = `SET_IDP_LIST ${NAME}`;
export const SET_PUBLIC_TOKEN = `SET_PUBLIC_TOKEN ${NAME}`;
export const ADD_BANNER = `ADD_BANNER ${NAME}`;
export const REMOVE_BANNER = `REMOVE_BANNER ${NAME}`;
export const SET_GLOBAL_HEADER_VISIBILITY = `SET_GLOBAL_HEADER_VISIBILITY ${NAME}`;
export const SET_GLOBAL_HEADER_VISIBILITY_ON_CURRENT_ROUTE = `SET_GLOBAL_HEADER_VISIBILITY_ON_CURRENT_ROUTE ${NAME}`;
export const SET_DEMO_DAY_BANNER_VISIBILITY = `SET_DEMO_DAY_BANNER_VISIBILITY ${NAME}`;
export const UPDATE_SESSION_VERIFICATION_DETAILS = `UPDATE_SESSION_VERIFICATION_DETAILS ${NAME}`;
export const SET_SHORTCUT_TOAST_VISIBILITY = `SET_SHORTCUT_TOAST_VISIBILITY ${NAME}`;
export const SET_ORG_WORKSPACE_DETAILS = `SET_ORG_WORKSPACE_DETAILS ${NAME}`;
export const CLEAR_ORG_WORKSPACE_DETAILS = `CLEAR_ORG_WORKSPACE_DETAILS ${NAME}`;
export const SET_CHILD_ID = `SET_CHILD_ID ${NAME}`;
export const OTP_TYPE = {
  EMAIL_LOGIN: "EMAIL_LOGIN",
  PHONE_LOGIN: "PHONE_LOGIN",
  FORGOT_PASSWORD: "FORGOT_PASSWORD",
  SESSION_VERIFICATION: "SESSION_VERIFICATION",
};
export const SENTRAL_PORTAL_DETAILS = `SENTRAL_PORTAL_DETAILS ${NAME}`;
export const SET_SSO_REQUEST_INITIATED_FAILED = `SET_SSO_REQUEST_INITIATED_FAILED ${NAME}`;
export const SET_SAML_INITIATED_DETAILS = `SET_SAML_INITIATED_DETAILS ${NAME}`;
export const UPDATE_MFA_VERIFICATION_DETAILS = `UPDATE_MFA_VERIFICATION_DETAILS ${NAME}`;
export const SETUP_MFA_VERIFICATION_DETAILS = `SETUP_MFA_VERIFICATION_DETAILS ${NAME}`;
